<template>
  <header id="masthead" class="navbar">
    <div class="container">
      <a target="_blank" href="https://www.wirecard.com" class="navbar-brand">
        <div class="brand-inner brand-wirecard">
          <img src="../assets/logo.png" width="148">
        </div>
      </a>

      <!-- <nav class="top-menu d-none d-md-block">
        <ul>
          <li><a href="#">{{ $t('appHeader.services') }}</a></li>
          <li><a href="#">{{ $t('appHeader.company') }}</a></li>
          <li><a href="#">{{ $t('appHeader.resources') }}</a></li>
        </ul>
      </nav> -->

      <div class="navbar-right clearfix">
        <!-- <div class="logout"><font-awesome-icon :icon="['fas', 'sign-in-alt']" /></div> -->
        <!-- <locale-switch></locale-switch> -->
        <!-- <div class="mobile-top-menu">
          <a class="toggle-top-menu" href="#">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </a>
        </div> -->
      </div>
    </div>
  </header>
</template>

<script>
import LocaleSwitch from './LocaleSwitch.vue'

export default {
  name: 'Header',
  components: {
    'locale-switch': LocaleSwitch
  },
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
